import { render, staticRenderFns } from "./perturbedgene.vue?vue&type=template&id=435339ff&"
import script from "./perturbedgene.vue?vue&type=script&lang=js&"
export * from "./perturbedgene.vue?vue&type=script&lang=js&"
import style0 from "./perturbedgene.vue?vue&type=style&index=0&id=435339ff&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports